import * as ActionTypes from './actions';

const initialState = [
	{
		id: 1,
		culture: 'en-GB',
		image: 'flag-gb.svg',
		name: 'english',
		state: 'undefined'
	}/*,
	{
		id: 2,
		name: 'bg-BG',
		image: 'flag-bg.png',
		resource: 'bulgarian',
		state: 'undefined'
	},
	{
		id: 4,
		name: 'de-DE',
		image: 'flag-de.png',
		resource: 'deutsch',
		state: 'undefined'
	}


	{
		id: 3,
		name: 'ru-RU',
		image: 'flag-ru.png',
		resource: 'russian',
		state: 'undefined'
	}
 */
];

const language = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.LANGUAGES_SUCCESS:
			const allLanguages = action.response;

			return allLanguages.map(language => ({
				...language,
				image: `flag-${language.culture.substring(language.culture.length - 2).toLowerCase()}.svg`,
				state: language.isDefault ? 'active' : 'undefined'
			}));
		case ActionTypes.CHANGE_LANGUAGE:
			return state.map(t => {
				if (t.culture === action.language) {
					return { ...t, state: 'active' };
				} else {
					return { ...t, state: 'undefined' };
				}
			});
		default:
			return state;
	}
};

export default language;

export const getActiveLanguage = (state) => {
	const selectedLanguage = state.find(l => l.state === 'active');
	if (selectedLanguage)
		return selectedLanguage.culture;

	return 'en-GB';
};